import React from 'react';
import './App.css';
import { P } from '@grubbe/ui';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <P color="white">Not Found...</P>
      </header>
    </div>
  );
}

export default App;
